'use client'

import { Input } from '@ui/components/shadcn/ui/input'

import { BaseFieldProps, FieldShell } from './FieldShell'

export function TextField({
  type = 'text',
  autoComplete,
  inputMode,
  placeholder,
  locked,
  ...shell
}: BaseFieldProps & {
  type?: string
  autoComplete?: string
  inputMode?: 'text' | 'email' | 'tel' | 'numeric'
  placeholder?: string
  locked?: boolean
}) {
  return (
    <FieldShell<string> {...shell}>
      {({ field, controlProps }) => (
        <Input
          {...controlProps}
          type={type}
          autoComplete={autoComplete}
          inputMode={inputMode}
          placeholder={placeholder}
          readOnly={locked}
          className={locked ? 'bg-muted text-muted-foreground' : undefined}
          value={field.state.value}
          onChange={(event) => field.handleChange(event.target.value)}
          onBlur={field.handleBlur}
        />
      )}
    </FieldShell>
  )
}
